import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { reverse } from 'ramda'
import React from 'react'

import { ContactType, TGetFileFunction } from '@/app/module/conversations/types'
import { SMSLog, WhatsAppLog } from '@/app/types/log'

import Part from './parts'

type Props = {
  activeContact: ContactType

  getFile: TGetFileFunction
  onLoadMore: () => void
}

const History: React.FC<Props> = ({ activeContact, getFile, onLoadMore }) => {
  const renderedHistory = React.useMemo(() => {
    if (!activeContact.history) {
      return null
    }
    return reverse(activeContact.history).map((part: WhatsAppLog | SMSLog) => (
      <Part getFile={getFile} type={part.type} key={part.id} part={part} />
    ))
  }, [activeContact.history, getFile])

  return (
    <Container>
      {!!activeContact.nextPage && (
        <Button variant="text" onClick={onLoadMore}>
          Load older messages
        </Button>
      )}
      {renderedHistory}
    </Container>
  )
}

const Container = styled('div')(() => ({
  padding: '10px 10px 0px',
  textAlign: 'center',
  background: 'rgb(245, 245, 245)',
  transition: 'height 0.1s',
  position: 'relative',
}))

export default History
